import { render, staticRenderFns } from "./DistrictList.vue?vue&type=template&id=2a51c9b8&scoped=true&"
import script from "./DistrictList.vue?vue&type=script&lang=js&"
export * from "./DistrictList.vue?vue&type=script&lang=js&"
import style0 from "./DistrictList.vue?vue&type=style&index=0&id=2a51c9b8&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a51c9b8",
  null
  
)

export default component.exports